/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Not_ConfirmedInputs */

const en_issue_not_confirmed = /** @type {(inputs: Issue_Not_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`not confirmed`)
};

/**
* | output |
* | --- |
* | "not confirmed" |
*
* @param {Issue_Not_ConfirmedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_not_confirmed = /** @type {((inputs?: Issue_Not_ConfirmedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Not_ConfirmedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_not_confirmed(inputs)
});